var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("Not Found")]),_c('div',{staticClass:"msg"},[_vm._v("The requested URL was not found on this server.")]),_c('el-button',{attrs:{"plain":""},on:{"click":_vm.goback}},[_vm._v("back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }